/**
 * Récupère une valeur passéé en GET dans l 'url
 *
 * @return {string} la valeur
 */

function getQuerystring(key, default_) {
    // Liens vers une page produit
    if (default_ === null || default_ === undefined) {
        default_ = '';
    }
    key = key.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
    var regex = new RegExp("[\\?&]" + key + "=([^&#]*)");
    var qs = regex.exec(window.location.href);
    if (qs === null) return default_;
    else return qs[1];
}

/**
 * Récupère le nom de domaine
 * Exple: dev.magnetic.coop
 *
 * @param {*} url
 *
 * @return {string} le domaine
 */
function getHostName(url) {
    var match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);
    if (match != null && match.length > 2 && typeof match[2] === 'string' && match[2].length > 0) {
        return match[2];
    } else {
        return null;
    }
}

export {
    getQuerystring,
    getHostName
};